import React, { memo } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const QuestionItem = ({ blocks, children }) => (
  <S.Container blocks={blocks}>{children}</S.Container>
);

export default memo(QuestionItem);

QuestionItem.defaultProps = {
  blocks: 7,
};
QuestionItem.propTypes = {
  blocks: PropTypes.number,
  children: PropTypes.node.isRequired,
};
